import { Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.svg";
import LogoStg from "../assets/logo-stg.svg";
import LogoSbx from "../assets/logo-sbx.svg";
import LogoLocal from "../assets/logo-local.svg";
import { sideBarOptions } from "./sidebarOptions";
import { useAuthenticatedUser } from "../components/Auth/AuthContext";
import { ViewAsAdminToggle } from "../components/Admin/ViewAsAdminToggle";
import { getEnvironment } from "../util/getEnvironment";
import { unreachable } from "../util/unreachable";
import { GoToAdminPage } from "../components/Admin/GoToAdminPage";
import { isViewAsAdmin } from "../util/viewAsAdmin";

const FlexeCharge = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="951"
    height="912"
    viewBox="0 0 951 912"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="277.155"
      y="750.797"
      width="523.595"
      height="99.2242"
      rx="49.6121"
      fill="#00DBDB"
    />
    <rect
      x="277.155"
      y="104.044"
      width="523.595"
      height="99.2242"
      rx="49.6121"
      fill="#00DBDB"
    />
    <rect
      x="116.295"
      y="427.415"
      width="523.595"
      height="99.2242"
      rx="49.6121"
      fill="#F79494"
    />
  </svg>
);

export const SideBar = () => {
  const user = useAuthenticatedUser();
  const viewAsAdmin = isViewAsAdmin();
  const env = getEnvironment();
  let logoSrc;
  switch (env) {
    case "STG":
      logoSrc = LogoStg;
      break;
    case "SBX":
      logoSrc = LogoSbx;
      break;
    case "LOCAL":
      logoSrc = LogoLocal;
      break;
    case "PRD":
      logoSrc = Logo;
      break;
    default:
      return unreachable(env);
  }
  return (
    <Sider width={250} breakpoint="lg" className="min-h-screen" theme="light">
      <div className="py-5 flex justify-center gap-2 items-center border-b ">
        {user?.partner_id === "fcharge" ? (
          <FlexeCharge className="w-10 h-10" />
        ) : (
          <img src={logoSrc} alt="Pleevi Logo" className="w-10 h-10" />
        )}
      </div>
      <Menu
        theme="light"
        defaultSelectedKeys={["/sites"]}
        items={sideBarOptions
          .filter((option) => {
            if (option.adminOnly && !viewAsAdmin) {
              return false;
            }
            if (option.partnerOnly && user?.type === "site_owner_access") {
              return false;
            }
            return true;
          })
          .map((option) => ({
            ...option,
            label: <Link to={option.key}>{option.label}</Link>,
          }))}
      />
      <ViewAsAdminToggle />
      <GoToAdminPage />
    </Sider>
  );
};
